import React, { useEffect } from "react";
import {
	Divider,
	List,
	ListItem,
	ListItemText,
	ListSubheader,
	ListItemIcon,
	Box,
	CircularProgress,
} from "@mui/material";
import { Link } from "react-router-dom";
import { useTheme } from "@mui/styles";
import { useDispatch, useSelector } from "react-redux";
import redlightLogo from "./redlightLogo.png";
import redlightLogoDark from "./redlightLogoDark.png";

import { selectGenreOrCategory } from "../../features/currentGenreOrCategory";
import { useGetGenresQuery } from "../../services/TMDB";
import useStyles from "./styles";
import genreIcons from "../../assets/genres";

const categories = [
	{ label: "Popular", value: "popular" },
	{ label: "Top Rated", value: "top_rated" },
	{ label: "Upcoming", value: "upcoming" },
];
// const redLogo = <img src={redlightLogo} alt="/" />;
// const blueLogo = <img src={redlightLogoDark} alt="/" />;

const Sidebar = ({ setMobileOpen }) => {
	const { genreIdOrCategoryName } = useSelector(
		(state) => state.currentGenreOrCategory
	);
	const theme = useTheme();
	const classes = useStyles();
	const { data, isFetching } = useGetGenresQuery();
	const dispatch = useDispatch();

	console.log(data, "Genres - Sidebar");

	useEffect(() => {
		setMobileOpen(false);
	}, [genreIdOrCategoryName]);
	// useEffect(() => {
	// 	setMobileOpen(false);
	// }, [genreIdOrCategoryName]);

	return (
		<>
			<Link to="/" className={classes.imageLink}>
				<img
					className={classes.image}
					src={theme.palette.mode === "light" ? redlightLogo : redlightLogoDark}
					alt="Redlight LOGO"
				/>
			</Link>
			<Divider />

			<List>
				<ListSubheader> Categories </ListSubheader>
				{categories.map(({ label, value }) => (
					<Link key={value} className={classes.links} to="/">
						<ListItem onClick={() => dispatch(selectGenreOrCategory(value))} button>
							<ListItemIcon>
								<img
									src={genreIcons[label.toLowerCase()]}
									className={classes.genreImage}
									height={30}
								/>
							</ListItemIcon>
							<ListItemText primary={label} />
						</ListItem>
					</Link>
				))}
			</List>

			<Divider />
			<List>
				<ListSubheader> Genres </ListSubheader>
				{isFetching ? (
					<Box display="flex" justifyContent="center">
						<CircularProgress />
					</Box>
				) : (
					data.genres.map(({ name, id }) => (
						<Link key={name} className={classes.links} to="/">
							<ListItem onClick={() => dispatch(selectGenreOrCategory(id))} button>
								<ListItemIcon>
									<img
										src={genreIcons[name.toLowerCase()]}
										className={classes.genreImage}
										height={30}
									/>
								</ListItemIcon>
								<ListItemText primary={name} />
							</ListItem>
						</Link>
					))
				)}
			</List>
		</>
	);
};

export default Sidebar;
